import { AgGridReact } from '@mint-lib/ag-grid/react';

import {
  ClientSideRowModelModule,
  ModuleRegistry,
  type ColDef,
} from '@mint-lib/ag-grid/community';
import { LoadingCell } from '@mint-lib/ag-grid/components';
import { createDefaultColumn } from '@mint-lib/ag-grid/factory';
import { Skeleton } from '@mint-lib/tw-components';

ModuleRegistry.registerModules([ClientSideRowModelModule]);

const columnDefs: ColDef[] = [
  { field: 'checkbox', minWidth: 36, maxWidth: 36, width: 36 },
  { field: 'userName', flex: 1, minWidth: 160 },
  { field: 'role', flex: 1, minWidth: 160 },
  { field: 'status', flex: 1, minWidth: 140 },
  { field: 'labels', flex: 1.5, minWidth: 260 },
  { field: 'email', flex: 1.5, minWidth: 200 },
  { field: 'actions', minWidth: 60, maxWidth: 60, width: 60, pinned: 'right' },
];

const defaultColDef: ColDef = createDefaultColumn({
  headerComponent: LoadingCell,
  cellRenderer: LoadingCell,
  loadingCellRenderer: LoadingCell,
  sortable: false,
  suppressHeaderMenuButton: true,
  suppressMovable: true,
  resizable: false,
});

const rowData = Array.from({ length: 30 }).map(() => ({ value: null }));

const TableSkeleton = () => {
  return (
    <div className="flex h-full flex-col overflow-hidden bg-ui-primary">
      <div className="min-h-0 flex-1">
        <AgGridReact
          className="[&_.ag-root-wrapper]:border-none!"
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          rowData={rowData}
          suppressHeaderFocus
          suppressCellFocus
          loading={false}
          suppressNoRowsOverlay
        />
      </div>
      <div className="flex h-10 shrink-0 items-center justify-end gap-2 px-3">
        <Skeleton variant="rounded" className="h-4 w-32" />
        <Skeleton variant="circle" className="h-5 w-5" />
        <Skeleton variant="circle" className="h-5 w-5" />
        <Skeleton variant="rounded" className="h-4 w-24" />
        <Skeleton variant="circle" className="h-5 w-5" />
        <Skeleton variant="circle" className="h-5 w-5" />
      </div>
    </div>
  );
};

export default TableSkeleton;
